import { Heading16 } from 'approot/shared/styles/typography.style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { MoreInfo } from '../more-information/more-information-toolip';

const ComponentAltTextTooltip = () => (
  <MoreInfo>
    <Heading16 as="h2" marginBottom={0} colour={grey1}>
      What is Alt Text?
    </Heading16>
    Alt text (alternative text) provides a textual description of an image for
    people who are blind or have low vision. It should concisely convey the
    subjects, setting, actions, and other relevant details in the image,
    enabling these users to understand its content and context.
  </MoreInfo>
);

export default ComponentAltTextTooltip;
